import React, { useState, useEffect } from 'react'
import { Route, Link, useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../providers/AuthProvider'

import { Button, IconButton, Tooltip } from '@mui/material'
import AdminFrame from '../AdminFrame'

import Fab from '@mui/material/Fab'
import AddIcon from '@mui/icons-material/Add'

import catMap from '../../lib/catMap'

import axios from 'axios'

export default function QuestionnaireShow() {
  const auth = useAuth()
  const navigate = useNavigate()

  const { id } = useParams()
  const [ isLoading, setIsLoading ] = useState(false)


  const qnnDefault = {
    name: '',
    questions: []
  }
  const [ qnn, setQnn ] = useState(qnnDefault)
  useEffect(() => {
    axios.get('/api/questionnaires/' + id).then((res) => {
      // console.log(res)
      setQnn(res.data)
    })
  }, [])

  const summaryDefault = {
    name: '',
    progress: [],
    totalProgress: 0
  }
  const [ summary, setSummary ] = useState(summaryDefault)
  useEffect(() => {
    axios.get('/api/questionnaires/' + id + '/summary').then((res) => {
      // console.log(res)
      setSummary(res.data)
    })
  }, [])

  const generateReport = () => {
    setIsLoading(true)
    axios.post('/api/questionnaires/' + id + '/generate_report').then((res) => {
      setIsLoading(false)
      window.location = window.location
    }).catch(
      err => {
        console.log(err)
        setIsLoading(false)
      }
    )
  }



  const qnnKeys = 'id name industry number_of_questions actions'.split(' ')
  const qnnLabels = {
    id: "ID",
    name: "Name",
    industry: "Industry",
    number_of_questions: "# of Questions",
    actions: "Actions"
  }

  const summaryHeaders = ['Section Name', 'Percent Done']
  const summaryProgress = []


  for (let catSlug in summary.progress) {
    const sectionProgress = []
    sectionProgress.push(catMap[catSlug].name)
    sectionProgress.push(`${summary.progress[catSlug].progress.toFixed(1)}%`)
    summaryProgress.push(sectionProgress)
  }

  const questionHeaders = [ 'ID', 'name id', 'Question', 'Status', 'Answer' ]
  const statusMap = {
    0: 'UNANSWERED',
    1: 'ANSWERED',
    2: 'NOT_APPLICABLE',
    3: 'WAS_SKIPPED',
    4: 'HELP_REQUESTED'
  }


  return(
      <div className="adminPage">

        <header className="pageHeader">
          <h2>{ qnn.name }</h2>
        </header>

        <div className="table horizontal">
          <table>
            <tbody>
              <tr>
                <td>ID</td>
                <td>{ qnn.id }</td>
              </tr>
              <tr>
                <td>Percent Complete</td>
                <td>{ summary.total_progress?.toFixed(1) }%</td>
              </tr>
              <tr>
                <td>Generate Report</td>
                <td>
                  <input type="button" 
                    onClick={generateReport} 
                    value="Generate" 
                    disabled={summary.total_progress !== 100 || summary.has_report} 
                  />
                </td>
              </tr>
              <tr>
                <td>Has Report</td>
                <td>
                  { 
                    (summary.has_report && qnn.report?.id) ? (
                      <Link target="_blank" rel="noopener noreferrer" to={`/insights/details?report_id=${qnn.report?.id}`}>
                        YES
                      </Link>
                    ) : 'no'
                  }
                </td>
              </tr>
              {qnn.report?.total_kgco2e && (
                <tr>
                  <td>Total kgCO2e</td><td>{ Math.round(qnn.report?.total_kgco2e * 100) / 100 }</td>
                </tr>
              )}
              <tr>
                <td>Data Review</td>
                <td>
                  { 
                    
                      <Link to={`/admin/questionnaires/${id}/data-review`}>
                        Click here for data review
                      </Link>
                    
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table">
          <table>
            <thead>
              <tr>
                { summaryHeaders.map((sumHead) => (<td>{sumHead}</td>)) }
              </tr>
            </thead>
            <tbody>
              { summaryProgress.map((secProg) => (<tr>{secProg.map((val) => (<td>{val}</td>))}</tr>)) }
            </tbody>
          </table>
        </div>

        <div className="table">
          <table>
            <thead>
              <tr>
                { questionHeaders.map((qHead) => (<td>{qHead}</td>)) }
              </tr>
            </thead>
            <tbody>
              {
                qnn.questions.map((q) => {
                  return (
                    <tr>
                      <td>{q.id}</td>
                      <td>{q.name_id}</td>
                      <td>{q.prompt_text.text}</td>
                      <td>{statusMap[q.status]}</td>
                      <td>{q.answer.text}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>

      </div>
  )
}
